// This file was auto-generated by store-graphql-schema.js

const Schema = {
  Types: {
    Annotation: 'Annotation',
    ArData: 'ArData',
    AssetDescription: 'AssetDescription',
    AssignedProjectUser: 'AssignedProjectUser',
    BillingAddonOption: 'BillingAddonOption',
    BillingPlan: 'BillingPlan',
    BillingSubscription: 'BillingSubscription',
    BillingSubscriptionAddon: 'BillingSubscriptionAddon',
    BillingSubscriptionOption: 'BillingSubscriptionOption',
    CollaboratingCompany: 'CollaboratingCompany',
    CollaboratingUser: 'CollaboratingUser',
    Comment: 'Comment',
    Company: 'Company',
    Device: 'Device',
    Document: 'Document',
    Favorite: 'Favorite',
    FavoritedGroup: 'FavoritedGroup',
    FavoritedProject: 'FavoritedProject',
    FavoritedUser: 'FavoritedUser',
    FeaturedPhoto: 'FeaturedPhoto',
    Group: 'Group',
    Guest: 'Guest',
    GuestProject: 'GuestProject',
    HistoricalCollaboration: 'HistoricalCollaboration',
    HomescreenModule: 'HomescreenModule',
    IAPReceipt: 'IAPReceipt',
    Industry: 'Industry',
    Integration: 'Integration',
    IntegrationAction: 'IntegrationAction',
    IntegrationPackage: 'IntegrationPackage',
    IntegrationPackageSetting: 'IntegrationPackageSetting',
    Invitation: 'Invitation',
    NodeLayoutAssetSectionSetting: 'NodeLayoutAssetSectionSetting',
    NodeLayoutCoverPageSetting: 'NodeLayoutCoverPageSetting',
    NodeLayoutSettingType: 'NodeLayoutSettingType',
    Notice: 'Notice',
    NotificationSetting: 'NotificationSetting',
    Organization: 'Organization',
    OrganizationCompany: 'OrganizationCompany',
    Photo: 'Photo',
    PhotoGallery: 'PhotoGallery',
    Plan: 'Plan',
    Project: 'Project',
    ProjectBlueprint: 'ProjectBlueprint',
    ProjectCollaboration: 'ProjectCollaboration',
    ProjectContact: 'ProjectContact',
    ProjectContributingGuest: 'ProjectContributingGuest',
    ProjectContributingTrustyUser: 'ProjectContributingTrustyUser',
    ProjectContributingUser: 'ProjectContributingUser',
    ProjectInvitation: 'ProjectInvitation',
    ProjectPage: 'ProjectPage',
    ProjectPageEditor: 'ProjectPageEditor',
    ProjectTask: 'ProjectTask',
    ProjectTaskList: 'ProjectTaskList',
    ProjectTemplate: 'ProjectTemplate',
    ProjectUser: 'ProjectUser',
    PublicCompany: 'PublicCompany',
    PublicProject: 'PublicProject',
    PublicProjectInvitation: 'PublicProjectInvitation',
    PublicTaskListPartner: 'PublicTaskListPartner',
    PublicUser: 'PublicUser',
    Report: 'Report',
    ReportNode: 'ReportNode',
    ReportNodeAssetContainerData: 'ReportNodeAssetContainerData',
    ReportNodeAssetSectionData: 'ReportNodeAssetSectionData',
    ReportNodeCoverPageData: 'ReportNodeCoverPageData',
    ReportNodeLayout: 'ReportNodeLayout',
    ReportNodeTextContainerData: 'ReportNodeTextContainerData',
    ReportPhoto: 'ReportPhoto',
    ReportProjectInfo: 'ReportProjectInfo',
    ReportSetting: 'ReportSetting',
    ReportShareLink: 'ReportShareLink',
    ReportTemplate: 'ReportTemplate',
    ReportTextSnippet: 'ReportTextSnippet',
    Resource: 'Resource',
    SearchGroup: 'SearchGroup',
    SearchUser: 'SearchUser',
    Showcase: 'Showcase',
    ShowcaseProject: 'ShowcaseProject',
    ShowcaseProjectMedia: 'ShowcaseProjectMedia',
    SubTask: 'SubTask',
    SubTaskTemplate: 'SubTaskTemplate',
    Tag: 'Tag',
    Task: 'Task',
    TaskList: 'TaskList',
    TaskListPartner: 'TaskListPartner',
    TaskListSection: 'TaskListSection',
    TaskListSectionTemplate: 'TaskListSectionTemplate',
    TaskListTemplate: 'TaskListTemplate',
    TaskTemplate: 'TaskTemplate',
    TrustyUser: 'TrustyUser',
    User: 'User',
    Video: 'Video',
    VoiceNote: 'VoiceNote',
  },
};

export default Schema;
